export const getCollapseHeaderStyles = (isOpen) => ({
    cursor: 'pointer',
    mb: isOpen ? 2 : 0,
    pb: isOpen ? 1 : 0,
    borderBottom: isOpen ? '1px solid' : 'none',
    borderColor: 'gray.300',
  });